// extracted by mini-css-extract-plugin
export var contactSection = "Contact-module--contactSection--2esDK";
export var section = "Contact-module--section--2kFog";